import api from '@/services/api';
import { Language } from '@/types/languages';
import { PaginatedResponse } from '@/types/common';
import {
  ContextType,
  ContextTopic,
  ContextTerritory,
  Context,
  CreateContextData,
  ContextQueryParams,
} from '@/types/contexts';

export const contextsService = {
  async getAll(params?: ContextQueryParams): Promise<PaginatedResponse<Context>> {
    const queryParams = new URLSearchParams();
    
    const offset = params?.offset ?? 0;
    const limit = params?.limit ?? 1000;
    
    queryParams.append('offset', offset.toString());
    queryParams.append('limit', limit.toString());
    
    if (params?.q) {
      queryParams.append('q', params.q);
    }
    
    const url = `/contexts?${queryParams.toString()}`;
    const response = await api.get<PaginatedResponse<Context>>(url);
    return response.data;
  },

  async create(data: CreateContextData): Promise<Context> {
    const response = await api.post<Context>('/contexts', data);
    return response.data;
  },

  async getLanguages(): Promise<PaginatedResponse<Language>> {
    const response = await api.get<PaginatedResponse<Language>>('/contexts/languages');
    return response.data;
  },

  async getTypes(): Promise<PaginatedResponse<ContextType>> {
    const response = await api.get<PaginatedResponse<ContextType>>('/contexts/types');
    return response.data;
  },
};